/**
 * @generated SignedSource<<314512eacabdb561ee6ce3d92eac86b3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type quizPostiesQuizArticle$data = {
  readonly quizIds: ReadonlyArray<string | null | undefined> | null | undefined;
  readonly " $fragmentType": "quizPostiesQuizArticle";
};
export type quizPostiesQuizArticle$key = {
  readonly " $data"?: quizPostiesQuizArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"quizPostiesQuizArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "quizPostiesQuizArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "quizIds",
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "56732693fd7abbc85c6d40977423043c";

export default node;
